<div *ngIf="(currentSnapshot$ | async) ? 'present' : 'absent' as currentSnapshot">
  <div *ngIf="(snapshotLoading$ | async) ? 'loading' : 'not-loading' as loading">
    <div *ngIf="currentSnapshot === 'present'">
      <div (click)="snapshotSummaryClick($event)" class="snapshot snapshot-title">
        <mat-icon class="icon">{{ (snapshotIsReady$$ | async) ? 'description' : 'insert_drive_file' }}</mat-icon>
        <span *ngIf="showText">
          {{ 'COMMON.TERMS.SNAPSHOT_REPORT' | translate }}
        </span>
      </div>
    </div>

    <div
      *ngIf="currentSnapshot === 'absent' && loading === 'not-loading' && accountGroup"
      (click)="onSnapshotCreatePressed(accountGroup)"
      class="snapshot snapshot-title"
    >
      <mat-icon class="icon">note_add</mat-icon>
      <a *ngIf="showText">
        {{ 'ACCOUNT_DETAILS.CALL_TO_ACTIONS.CREATE_SNAPSHOT_REPORT' | translate }}
      </a>
    </div>
    <div *ngIf="currentSnapshot === 'absent' && loading === 'loading'" class="snapshot snapshot-loading">
      <mat-spinner diameter="20" class="icon"></mat-spinner>
      <div *ngIf="showText">
        {{ 'COMMON.TERMS.SNAPSHOT_REPORT' | translate }}
      </div>
    </div>
  </div>
</div>

<ng-template #openScorecard>
  <ng-container>
    <app-snapshot-scorecard
      [partnerId]="partnerId"
      [accountGroupId]="accountGroup.accountGroupId"
      [trackingCategory]="'account-details-snapshot'"
      [trigger]="displaySnapshotSummaryClick$ | async"
      [showEditButton]="hasEditAccess$ | async"
      (refreshReportClickedEvent)="onSnapshotCreatePressed(accountGroup)"
    ></app-snapshot-scorecard>
  </ng-container>
</ng-template>
